import { create } from 'zustand';

/**
 * Tiny store backing the auth-gate modal. Kept separate from
 * authStore so that opening the modal is a pure UI concern and does
 * not trigger resubscriptions on session fields.
 */
interface AuthGateState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export const useAuthGateStore = create<AuthGateState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));

/** Imperative opener usable outside React (e.g. from event handlers). */
export function openAuthGate() {
  useAuthGateStore.getState().open();
}
